import styled, { css } from 'styled-components';

export const Warning = styled.div<{ $alignEnd?: boolean }>`
  display: flex;
  align-items: center;

  margin: 0.5rem 0;
  width: 100%;
  flex-direction: row;
  gap: 1rem;
  /* 
  white-space: nowrap;
  overflow: hidden;

  text-overflow: ellipsis; */

  ${({ $alignEnd }) =>
    $alignEnd &&
    css`
      width: auto;
      flex: 1;
      min-width: 0;
    `}
`;

export const ButtonSlot = styled.div`
  display: flex;
  flex-shrink: 0;
  margin-left: auto;
`;

interface Props {
  iconColor?: 'danger' | 'warning' | 'tertiary' | 'white';
}
export const Icon = styled.div<Props>`
  color: ${(props) =>
    props.theme.colors?.[props.iconColor ? props.iconColor : 'gray01']};
`;

export const P = styled.p<{ $alignEnd?: boolean }>`
  ${({ $alignEnd }) =>
    $alignEnd &&
    css`
      min-width: 0;
    `}
`;
